// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--_uv0B"};